import React from 'react'
import PropTypes from 'prop-types'

// Foot of an inline config panel (hint left, actions right); the step footer is WizardFooter.

const SpecConfigFooter = ({ hint, children }) => (
  <div className="gl-event-setup-sc-foot">
    {hint && <div className="gl-event-setup-sc-foot-hint">{hint}</div>}
    <div className="gl-event-setup-sc-foot-actions">{children}</div>
  </div>
)

SpecConfigFooter.propTypes = {
  hint: PropTypes.node,
  children: PropTypes.node.isRequired,
}

export default SpecConfigFooter
